import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyCGGyaYeP-vMoSKRZhbLZsu_D41Jq6Gq58",
    authDomain: "slack-clone-2-bdb60.firebaseapp.com",
    projectId: "slack-clone-2-bdb60",
    storageBucket: "slack-clone-2-bdb60.appspot.com",
    messagingSenderId: "1016915208347",
    appId: "1:1016915208347:web:80215de40bb092e8503e3e"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig)
  const db = firebaseApp.firestore()
  const auth = firebase.auth()
  const provider = new firebase.auth.GoogleAuthProvider()

  export { auth, provider, db }

